// website crawling is consolidated inside repo creation
// Comparision qna, selection mode and cleassify query are already consolidated in qna
export const OPERATION_LABELS = Object.freeze({
    REPO_CREATION: 'Repo creation',
    FILE_UPLOAD: 'File upload',
    RECRAWL: 'Recrawl',
    QNA: 'Q&A',
    KG_CREATION: 'Knowledge graph creation',
    AGENT_CREATION: 'Agent creation',
    EXTRACTION: 'Extraction',
    AUTO_EXTRACTION: 'Auto extraction',
    'DATABASE QUERY': 'Database query', // legacy rows only; new dashboard queries use DASHBOARD
    DASHBOARD: 'Dashboard',
    // Usage consumed by a run the user cancelled before it finished (SubscriptionService.charge_cancelled_run).
    REPO_CREATION_CANCELLED: 'Repo creation (cancelled)',
    FILE_UPLOAD_CANCELLED: 'File upload (cancelled)',
    EXTRACTION_CANCELLED: 'Extraction (cancelled)',
    AUTO_EXTRACTION_CANCELLED: 'Auto extraction (cancelled)',
    KG_CREATION_CANCELLED: 'Knowledge graph creation (cancelled)',
});
